<div id="shared-avater" mat-card-avatar class="avatar" [ngStyle]="getStyles()">
  <ng-content id="avatar-content"></ng-content>
</div>
